import { useCallback, useEffect, useState } from 'react'

import { useOnScreen } from 'shared/hooks/useOnScreen'

/**
 * @file VisibleState.
 * @author Pavel Kurov
 * VisibleState необходим для автоматического ререндера раз в 100 сек, если триггер всегда в окне,
 *  например при движении снизу вверх т.к. всегда будет inVisible (useOnScreen)
 * то необходимо делать триггер юзеффекта заново. Достигается это с помощью второго стейта
 */

const useInfiniteVerticalScroll = <T>({ data, loadingCount }: { data: any; loadingCount: number }) => {
  const [state, setState] = useState<{ prev: number; next: number; current: T[] }>({
    prev: -loadingCount,
    next: 0,
    current: [],
  })

  const [visibleState, setVisibleState] = useState(false)

  const getMoreData = useCallback(
    (dataProp, stateProp) => {
      setState({
        prev: stateProp.prev + loadingCount,
        next: stateProp.next + loadingCount,
        current: stateProp.current.concat(dataProp.slice(stateProp.prev + loadingCount, stateProp.next + loadingCount)),
      })
    },
    [loadingCount],
  )

  useEffect(() => {
    const newCount = {
      prev: -loadingCount,
      next: 0,
    }
    setState({
      ...state,
      ...newCount,
    })

    getMoreData(data, { ...newCount, current: [] })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const { containerRef, isVisible } = useOnScreen()

  useEffect(() => {
    if (isVisible) {
      setVisibleState(true)
      getMoreData(data, state)
    }
    const timeoutId = setTimeout(() => {
      setVisibleState(false)
    }, 100)
    return () => {
      clearTimeout(timeoutId)
    } //
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, visibleState])

  return { current: state.current, ref: containerRef, isVisible }
}

export default useInfiniteVerticalScroll
